import { registerStore } from '../../common/utilsClient/multiReducer';

const store = registerStore({
  path: 'ui.screens.PatientsDirectory',
  initialState: {
    dialogs: {},
    // review:accepted: starting with [] does not stop the quick-search filters being seeded. The seeding effect in components/Filters/index.jsx compares `simpleFilters` with its own previous value and calls onChange(simpleFilters) on mount; it never reads the stored value. So the store becomes non-empty one render later and the table gate in PatientsTable.js opens.
    filters: [],
  },
});

export default store;
